module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/3.3-account-confirm.43301791.png";